import { cn } from '~/shared/lib/cn'
import { EMPTY_VALUE } from '../config'

export function CategoryValue({
  category,
  isMismatch = false,
  className,
}: {
  category: string | null | undefined
  isMismatch?: boolean
  className?: string
}) {
  return (
    <span
      className={cn(
        'text-[13px] leading-5 wrap-anywhere',
        { 'bg-swatch-yellow-100 text-swatch-yellow-900 rounded-xs px-1': isMismatch },
        { 'text-text-tertiary': !category },
        className,
      )}
    >
      {category || EMPTY_VALUE}
    </span>
  )
}
